import { Mesh, Program, Texture } from "ogl";

import fragment from "./shaders/fragment.glsl";
import vertex from "./shaders/vertex.glsl";

export default class {
  constructor({ node, geometry, gl, scene, screen, viewport, index }) {
    this.node = node;
    this.image = this.node.querySelector("img");

    this.hasOverlay = this.node.dataset.mediaOverlay !== undefined;
    this.geometry = geometry;
    this.gl = gl;
    this.scene = scene;
    this.screen = screen;
    this.viewport = viewport;
    this.x = window.scrollX;
    this.index = index;
    this.needsUpdatedBounds = false;

    this.createMesh();
    this.initialBounds = this.node.getBoundingClientRect();
    this.createBounds();

    this.onResize();

    // console.log(
    //   "%c Media ",
    //   "background: dodgerblue; color: #ffffff",
    //   "initialized"
    // );
  }

  createMesh = () => {
    const texture = new Texture(this.gl, {
      generateMipmaps: false,
    });

    const program = new Program(this.gl, {
      fragment,
      vertex,
      uniforms: {
        tMap: { value: texture },
        uPlaneSizes: { value: [0, 0] },
        uImageSizes: { value: [0, 0] },
        uViewportSizes: { value: [this.viewport.width, this.viewport.height] },
        uStrength: { value: 0 },
        uHasOverlay: { value: this.hasOverlay },
      },
      transparent: true,
    });

    this.image.addEventListener("load", (_) => {
      program.uniforms.uImageSizes.value = [
        this.image.naturalWidth,
        this.image.naturalHeight,
      ];
      texture.image = this.image;
      // console.log(
      //   "%c Media texture ",
      //   "background: cyan; color: black",
      //   "loaded from network",
      //   this.image.src
      // );
    });
    // get it from cache if it is already loaded
    if (this.image.complete) {
      program.uniforms.uImageSizes.value = [
        this.image.naturalWidth,
        this.image.naturalHeight,
      ];
      texture.image = this.image;
      // console.log(
      //   "%c Media texture ",
      //   "background: cyan; color: black",
      //   "loaded from cache",
      //   this.image.src
      // );
    }

    this.plane = new Mesh(this.gl, {
      geometry: this.geometry,
      program,
    });

    this.plane.setParent(this.scene);
  };

  createBounds = () => {
    this.bounds = this.node.getBoundingClientRect();
    this.offsetX = this.x;

    this.updateScale();

    this.plane.program.uniforms.uPlaneSizes.value = [
      this.plane.scale.x,
      this.plane.scale.y,
    ];
  };

  updateScale = () => {
    this.plane.scale.x =
      (this.viewport.width * this.bounds.width) / this.screen.width;
    this.plane.scale.y =
      (this.viewport.height * this.bounds.height) / this.screen.height;
  };

  updateX = (x = 0) => {
    this.plane.position.x =
      -(this.viewport.width / 2) +
      this.plane.scale.x / 2 +
      ((this.bounds.left - (x - this.offsetX)) / this.screen.width) *
        this.viewport.width;
  };

  updateY = (y = 0) => {
    this.plane.position.y =
      this.viewport.height / 2 -
      this.plane.scale.y / 2 -
      ((this.bounds.top - y) / this.screen.height) * this.viewport.height;
  };

  update = (scroll) => {
    this.x = scroll.x;

    if (scroll.isChanged && this.needsUpdatedBounds) {
      this.createBounds();

      this.needsUpdatedBounds = false;
    }

    this.updateX(scroll.x);
    this.updateY();

    this.plane.program.uniforms.uStrength.value =
      ((scroll.current - scroll.last) / this.screen.height) * 5;
  };

  onResize = (sizes) => {
    if (sizes) {
      const { screen, viewport } = sizes;

      if (screen) this.screen = screen;
      if (viewport) {
        this.viewport = viewport;

        this.plane.program.uniforms.uViewportSizes.value = [
          this.viewport.width,
          this.viewport.height,
        ];
      }
    }

    this.createBounds();
    this.needsUpdatedBounds = true;
  };
}
